import { ProjectWrapper, LinkButton } from '../GlobalStyles'
import { Carousel } from '../components/Carousel'
import { ImageLoader } from '../components/ImageLoader'

import mockups from '../assets/bookish/mockups.png'
import image1 from '../assets/bookish/image1.png'
import image2 from '../assets/bookish/image2.png'
import image3 from '../assets/bookish/image3.png'
import image4 from '../assets/bookish/image4.png'
import image5 from '../assets/bookish/image5.png'
import image6 from '../assets/bookish/image6.png'
import image7 from '../assets/bookish/image7.png'
import image8 from '../assets/bookish/image8.png'

export const FeaturedProject = () => {
  const projectImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
  ]

  return (
    <ProjectWrapper>
      <div className='description'>
        <p className='featuring'>featuring</p>
        <h1 className='title'>
          [ <b>bookish</b> ]
        </h1>
        <div className='summary'>
          <p className='type'>Full Stack Development, Mobile App</p>
          <p className='duration'>Solo Project • April – May 2023</p>
        </div>

        <div className='details'>
          <p>
            Bookish is a polished, user-focused book-tracking app designed as a modern alternative to Goodreads.  
            Engineered with React Native, it delivers a seamless cross-platform experience on both iOS and Android.
          </p>

          <div className='mockups'>
            <ImageLoader src={mockups} alt='Bookish app mockups' borderRadius='10px' />
          </div>

          <p>
            Core features include searching the Google Books API, creating custom shelves (Reading, To Read, Completed),  
            rating and reviewing titles, and receiving personalized, genre-based recommendations.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <Carousel images={projectImages} />
        </div>

        <div className='details'>
          <p>
            Adopted TypeScript on the frontend to enforce strict typing between the Google Books API responses  
            and our MongoDB schema, improving maintainability and reducing runtime errors.
          </p>
          <p>
            Established unit tests with Vitest for key components and custom search-input validation,  
            enhancing reliability and streamlining QA workflows.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <iframe
            className='video'
            src='https://www.youtube.com/embed/oLa1Qr_J1PM'
            title='Bookish Demo'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            allowFullScreen
          />
        </div>

        <div className='details'>
          <p>
            All source code is publicly available with comprehensive READMEs:{' '}
            <a
              href='https://github.com/v-prt/bookish-frontend'
              target='_blank'
              rel='noopener noreferrer'
            >
              Frontend
            </a>{' '}
            •{' '}
            <a
              href='https://github.com/v-prt/bookish-backend'
              target='_blank'
              rel='noopener noreferrer'
            >
              Backend
            </a>.  
            Bookish demonstrates my ability to architect and deliver complete cross-platform solutions.
          </p>
          <p>
            <b>Tech stack:</b> React Native · React Query · Expo · TypeScript · Node · Express · MongoDB · Mongoose · Vitest
          </p>
          <div className='buttons'>
            <LinkButton
              className='black'
              href='https://youtu.be/oLa1Qr_J1PM'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Demo
            </LinkButton>
            <LinkButton
              className='white'
              href='https://github.com/v-prt/bookish-frontend'
              target='_blank'
              rel='noopener noreferrer'
            >
              View on GitHub
            </LinkButton>
          </div>
        </div>
      </div>
    </ProjectWrapper>
  )
}
